<template>
  <div id="archive-sale">
    <!-- <YearProcessModal/> -->
    <!-- <SalesArchiveModal2 @add="getFilterdList"/> -->
    <SalesClosingModal @closed="initList"/>
    <SalesUnclosingModal @unclosed="initList"/>
    <!-- <BulkSendInvoice :dateFrom="dateFrom" :dateTo="dateTo"/> -->
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#">{{ translations('navbar.sale_management') }}</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">{{ translations('sale.archive_sale') }}</li>
      </ol>
    </nav>
    <div class="container-fluid main-container">
      <div class="form-inline mb-4 justify-content-between">
        <div class="form-group">
          <div class="d-flex flex-wrap">
            <!--           <div class="form-group mr-2">
                        <button class="btn btn-primary" type="button" data-toggle="modal" data-target="#SalesArchiveModal2">追加</button>
                      </div> -->
            <div class="form-group mr-1">
              <input id='dtSearch' type="text" class="form-control" v-model='dtSearch' :placeholder="translations('common.keyword_search')">
            </div>
            <div v-if="!checkShowWarehouse(status_id)" class="form-group mr-3">
              <v-select
                :value="master_clients.find(m => m.id === client_id) || ''"
                :options="master_clients"
                label="name"
                :placeholder="translations('sale.supplier')"
                :id="client_id"
                @input="changedClients">
              </v-select>
            </div>
            <div class="form-group mr-3 d-flex align-items-center flex-wrap">
              <span class="text-nowrap mr-1">{{translations('common.period')}}</span>
              <!--            <input v-model="dateFrom" type="date" class="form-control" @blur='triggerDateFilter("dateFrom")' @focus="tempDateField = dateFrom">-->
              <input v-model="dateFrom" type="date" class="form-control">
              <span class="mr-1 ml-1">〜</span>
              <!--            <input v-model="dateTo" type="date" class="form-control" @blur='triggerDateFilter("dateTo")' @focus="tempDateField = dateTo">-->
              <input v-model="dateTo" type="date" class="form-control">
            </div>
            <div class="form-group mr-1">
              <div class="dropdown">
                <button id='filterByBilling' class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{ getShipmentStatusTxt (translatedShipmentStatusList, status_id, 'name', this.translations('sale.display_all')) }}
                </button>
                <div class="dropdown-menu">
                  <a class='dropdown-item' v-for='(status, i) in translatedShipmentStatusList' :key='i' v-on:click='status_id=status.id'>{{ status.name }}</a>
                </div>
              </div>
            </div>
            <div v-if="checkShowWarehouse(status_id)" class="form-group mr-1">
              <div class="dropdown">
                <button id='filterByBilling' class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{ getWarehouseFromName (warehousesFrom, warehouseFrom, 'name', this.translations('sale.moved_from_warehouse')) }}
                </button>
                <div class="dropdown-menu">
                  <a class='dropdown-item' v-for='(warehouse, i) in warehousesFrom' :key='i' v-on:click='warehouseFrom=warehouse.id'>{{ warehouse.name }}</a>
                </div>
              </div>
            </div>
            <div v-if="checkShowWarehouse(status_id)" class="form-group mr-1">
              <div class="dropdown">
                <button id='filterByBilling' class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{ getWarehouseToName (warehousesTo, warehouseTo, 'name', this.translations('sale.destination_warehouse')) }}
                </button>
                <div class="dropdown-menu">
                  <a class='dropdown-item' v-for='(warehouse, i) in warehousesTo' :key='i' v-on:click='warehouseTo=warehouse.id'>{{ warehouse.name }}</a>
                </div>
              </div>
            </div>
            <div class="form-group ml-2">
              <div class="form-check">
                <input v-model="isShowClosed" class="form-check-input" type="checkbox" value="">
                <label class="form-check-label" for="checkShowShipped">
                  {{ translations('sale.display_monthly_closed_data') }}
                </label>
              </div>
            </div>
            <div class="form-group ml-2">
              <div class="form-check">
                <input v-model="displayAll" class="form-check-input pointer-clickable" id="displayAll" type="checkbox" value="" >
                <label class="form-check-label pointer-clickable" for="displayAll">
                  {{ translations('common.display_all') }}
                </label>
              </div>
            </div>
            <div class="form-group ml-2">
              <button class="btn btn-primary btn-sm" type="button" @click="submitSearch">{{translations('common.search')}}</button>
            </div>
          </div>
        </div>
        <div class="form-group" style="margin-left: auto">
          <div class="form-group" style="margin: 1px 10px 0 0">
            <button class="btn btn-primary btn-sm" type="button" @click="exportCsv">{{translations('common.csv_export')}}</button>
          </div>
          <div class="form-group mr-3">
            <span class="font-weight-bold mb-0" style="font-size:16px;">{{translations('sale.sales_quantity')}}： {{ totalQuantity.toLocaleString() }}  </span>
          </div>
          <div class="form-group mr-3">
            <span class="font-weight-bold mb-0" style="font-size:16px;">{{translations('sale.total_sales_amount')}}： {{ totalSaleAmount.toLocaleString() }}  </span>
          </div>
          <div class="form-group">
            <span class="font-weight-bold mb-0" style="font-size:16px;">{{translations('sale.total_gross_profit')}}： {{ totalGrossProfit.toLocaleString() }}  </span>
          </div>
          <div class="form-group">
          <button class="btn btn-link btn-sm decoration-underline" type="button" data-toggle="modal" data-target="#SalesClosingModal">{{ translations('sale.month_end_processing') }}</button>
<!--           <button class="btn btn-link btn-sm decoration-underline" type="button" data-toggle="modal" data-target="#BulkSendInvoice">請求書一斉送付</button> -->
          <button class="btn btn-link btn-sm decoration-underline" type="button" data-toggle="modal" data-target="#SalesUnclosingModal">{{ translations('sale.month_close_release_process') }}</button>
<!--           <button class="btn btn-secondary btn-sm" type="button" data-toggle="modal" data-target="#YearProcessModal">年度締め処理</button> -->
        </div>
        </div>
      </div>
      <div class="table-scroll mb-4">
        <v-data-table
          class="table table-striped table-hover table-1300 table-clickable"
          item-key="name"
          :headers="[
            // { text: 'ステータス', value: 'sales_status' },
             { text: 'No', sortable: false },
            { text: this.translations('sale.closing_process'), value: 'closing_flag' },
            { text: this.translations('sale.ship_date'), value: 'shipping_schedule_at' },
            { text: this.translations('sale.sale_date'), value: 'shipping_at' },
            { text: this.translations('sale.division'), value: 'division_type' },
            { text: this.translations('sale.order_number'), value: 'sales_number' },
            { text: this.translations('sale.ship_number'), value: 'ship_number' },
            { text: this.translations('sale.supplier'), value: 'younosuke_company_name' },
            { text: this.translations('sale.destination_name'), value: 'destination_name' },
            { text: this.translations('sale.shipping_warehouse'), value: 'kaishu_warehouse_name' },
            { text: this.translations('sale.total_amount'), value: 'total_amount' },
            { text: this.translations('sale.gross_profit'), value: 'gross_profit' },
            { text: this.translations('sale.client_order_number'), value: 'client_order_number' },
            { text: this.translations('sale.model'), value: 'model' },
            { text: this.translations('sale.jan_code'), value: 'jan_code' },
            { text: this.translations('sale.product_internal_memo'), value: 'internal_memo' },
            { text: this.translations('sale.closing_date'), value: 'closing_at' },
            { text: this.translations('sale.order_date'), value: 'sold_at' },
            { text: this.translations('sale.internal_memo'), value: 'note' },
            { text: this.translations('sale.remarks'), value: 'memo' },
          ]"
          :items="sales"
          :options.sync="options"
          :server-items-length="totalCount"
          hide-default-footer
          @page-count="pageCount = $event"
        >
          <template v-slot:body="{ items }">
            <tbody class="nowrap">
              <template v-if="!isEmpty">
                <tr  v-for="(sale, i) in items" :key='i' data-href="" @click="openSingleSales(sale)">
                  <td>{{i + 1}}</td>
                   <td>
                    <span class="badge" :class="(sale.closing_flag) ? 'badge-success' : 'badge-light'">
                      {{ (sale.closing_flag) ? translations('sale.billing_created') : translations('sale.billing_not_created') }}
                    </span>
                  </td>
                  <td>{{ sale.shipping_schedule_at ? formatDate(sale.shipping_schedule_at) : formatDate(sale.shipping_at) }}</td>
                  <td>{{ formatDate(sale.shipping_at) }}</td>
                  <td><DivisionTypeText :division_type="sale.division_type" :labelDefault="null" /></td>
                  <td>{{ sale.sales_number }}</td>
                  <td>{{ sale.ship_number || '-' }}</td>
                  <td>
                    <span v-if="sale.division_type !== 'B'">{{ sale.client_name }}</span>
                    <span v-else>{{sale.name_type_b_from }}</span>
                  </td>
                  <td>
                    <span v-if="sale.division_type !== 'B'">{{ sale.destination_name }}</span>
                    <span v-else>{{sale.name_type_b }}</span>
                  </td>
                  <td>
                    <ul>
                      <li v-for="(detail, i) in sale.details" :key="i">{{detail.warehouse || '&nbsp;'}}</li>
                    </ul>
                  </td>
                  <td class="right">{{ sale.total_amount.toLocaleString() }}</td>
                  <td class="right">{{ sale.gross_profit.toLocaleString() }}</td>
                  <td>
                    <ul>
                      <li v-for="(detail, i) in sale.details" :key="i">{{detail.client_order_number || '&nbsp;'}}</li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li v-for="(detail, i) in sale.details" :key="i">{{detail.model || '&nbsp;'}}</li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li v-for="(detail, i) in sale.details" :key="i">{{detail.jan_code || '&nbsp;'}}</li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li v-for="(detail, i) in sale.details" :key="i">{{sliceNote(detail.internal_memo) || '&nbsp;'}}</li>
                    </ul>
                  </td>
                  <td>{{ formatDate(sale.closing_at) }}</td>
                  <td>{{ formatDate(sale.sold_at) }}</td>
                  <td>{{ sliceNote(sale.note) }}</td>
                  <td>{{ sale.memo }}</td>
                </tr>
              </template>
              <template v-else>
                <tr class="odd">
                  <td valign="top" colspan="12" class="dataTables_empty">{{ isEmptyMsg }}</td>
                </tr>
              </template>
            </tbody>
          </template>
        </v-data-table>
      </div>
      <v-pagination v-model="page" :length="pageCount" :total-visible="11"></v-pagination>
    </div>
    <vue-element-loading :active="isSearching" :is-full-screen="true"/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import SalesClosingModal from '@/components/SalesClosingModal'
import SalesUnclosingModal from '@/components/SalesUnclosingModal'
import DivisionTypeText from '@/components/orders/DivisionTypeText'
import { OrderStatus, DivisionType } from '@/constants'
import { mapState } from 'vuex'
import { saveAs } from 'file-saver'
import Papa from 'papaparse'
import encoding from 'encoding-japanese'

export default {
  name: 'ArchiveSales',
  props: {},
  components: {
    VueElementLoading,
    // YearProcessModal,
    // SalesArchiveModal2,
    SalesClosingModal,
    SalesUnclosingModal,
    // BulkSendInvoice,
    DivisionTypeText
  },
  data () {
    return {
      sales: [],
      client_id: 0,
      dtSearch: '',
      isSearching: false,
      isShowClosed: false,
      dateFrom: '',
      dateTo: '',
      // tempDateField: '',
      isEmpty: false,
      isEmptyMsg: '',
      page: 1,
      pageCount: 0,
      totalCount: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      },
      status_id: 0,
      warehousesFrom: [],
      warehousesTo: [],
      warehouseFrom: 0,
      warehouseTo: 0,
      totalSaleAmount: 0,
      totalGrossProfit: 0,
      totalQuantity: 0,
      displayAll: false
    }
  },
  computed: {
    ...mapState(['currentLanguage']),
    master_clients () {
      return this.$store.getters['Master/getBillTo']
    },
    translatedShipmentStatusList () {
      const shipmentStatusList = [
        { id: 0, name: 'sale.display_all' },
        { id: 2, name: 'sale.shipping' },
        { id: 5, name: 'sale.move' }
      ]
      return shipmentStatusList.map(status => ({
        ...status,
        name: this.translations(status.name)
      }))
    }
  },
  watch: {
    // client_id () {
    //   this.initList()
    // },
    page () {
      this.getFilterdList()
    },
    options: {
      handler () {
        let visitCount = Number(localStorage.getItem('visitCountSales')) || 0
        if (visitCount > 0) {
          this.initList()
        }
      },
      deep: true
    }
  },
  created: function () {
    this.$store.dispatch('Master/checkBillTo')
    let storedFilter = this.$storage.get('salesFilter')
    if (storedFilter) {
      this.dtSearch = storedFilter.search
      this.client_id = storedFilter.client_id
      this.dateFrom = storedFilter.start_at
      this.dateTo = storedFilter.end_at
      this.isShowClosed = storedFilter.show_closed
      this.options.sortBy = storedFilter.orderbys
      this.options.sortDesc = storedFilter.is_descs
    }
    this.listWarehouses()
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    getStatus (statusID) {
      if (parseInt(statusID) === 2) {
        return '<span class="badge badge-success">請求済</span>'
      } else {
        return '<span class="badge badge-light">未請求</span>'
      }
    },

    async listSales () {
      try {
        let params = {
          clients_id: '',
          start_at: '',
          end_at: ''
        }
        let salesList = await this.$http.post(this.$api_url.sales_list, params)
        let $data = this.$invoiceTools.prepareResult(salesList.data, 'sales', 'ArchiveSales:listSales')
        if ($data.success === true) {
          this.sales = []
          for (const key in $data.data) {
            this.sales.push($data.data[key])
          }
          this.isEmpty = false
        } else {
          this.isEmpty = true
          this.isEmptyMsg = $data.data
          this.$toastr.error($data.data, this.translations('common.error'))
        }
      } catch (error) {
        console.log('ArchiveSales:listSales:catch(error): ', error)
        this.$toastr.error(this.translations('sale.notice_failed'), this.translations('common.error'))
      }
    },

    getFilterTxt (obj, input, output, _default) {
      if (input) {
        if (input === 0) return _default
        return this.$invoiceTools.getObjPropsById(obj, input, output)
      }
      return _default
    },

    formatDate (v, b = 0) {
      if (!v) return ''
      if (v.indexOf('-') > 0) {
        const x = /-/gi
        return v.replace(x, '/')
      } else {
        if (b) return v.substr(0, 4) + '-' + v.substr(4, 2) + '-' + v.substr(6, 2)
        else if (v.indexOf('/') > 0) return v
        else return v.substr(0, 4) + '/' + v.substr(4, 2) + '/' + v.substr(6, 2)
      }
    },

    // changeSearch (e) {
    //   console.log(e.target.value)
    //   this.$storage.set('ArchiveSales:dtSearch', e.target.value) // KEEP KEYWORD
    //   this.initList()
    // },

    // triggerDateFilter (source) {
    //   if (source === 'dateFrom' && this.dateFrom !== this.tempDateField) {
    //     this.initList()
    //   }
    //
    //   if (source === 'dateTo' && this.dateTo !== this.tempDateField) {
    //     this.initList()
    //   }
    // },

    initList () {
      if (this.page !== 1) {
        this.page = 1
      } else {
        this.getFilterdList()
      }
    },

    getFilterdList () {
      if (this.displayAll) {
        this.$storage.set('sale_display_all', this.displayAll)
        this.options.itemsPerPage = -1 // DISPLAY ALL
      } else {
        this.options.itemsPerPage = 10 // DISPLAY 10 ROWS
      }

      if (this.isSearching) {
        return
      }

      this.isSearching = true

      const offset = (this.page - 1) * this.options.itemsPerPage
      const limit = this.options.itemsPerPage
      const orderbys = JSON.parse(JSON.stringify(this.options.sortBy))
      const isDescs = JSON.parse(JSON.stringify(this.options.sortDesc))

      // let search = this.dtSearch
      // if (this.client_id) {
      //   search = ''
      // }

      let warehouseFrom = 0
      let warehouseTo = 0
      if (this.status_id === OrderStatus.MOVED) {
        warehouseFrom = this.warehouseFrom
        warehouseTo = this.warehouseTo
      }

      this.client_id = this.status_id === OrderStatus.MOVED ? 0 : this.client_id

      let params = {
        client_id: this.client_id,
        start_at: this.dateFrom,
        end_at: this.dateTo,
        show_closed: this.isShowClosed,
        offset: offset,
        limit: limit,
        orderbys: orderbys,
        is_descs: isDescs,
        search: this.dtSearch,
        status_id: this.status_id,
        warehouse_from: warehouseFrom,
        warehouse_to: warehouseTo
      }
      this.$storage.set('salesFilter', params)
      console.log('ArchiveSales:getFilterdList: ', params)

      this.$http.post(this.$api_url.sales_list, params).then(response => {
        const result = response.data
        if (result.status === true) {
          this.isEmpty = false
          this.isEmptyMsg = ''
          this.sales = result.list
          localStorage.setItem('visitCountSales', this.sales.length)
          this.totalSaleAmount = Number(result.total_sale_amount)
          this.totalGrossProfit = Number(result.total_gross_profit)
          this.totalQuantity = Number(result.total_quantity)
          this.totalCount = Number(result.total_count)
        } else {
          this.sales = []
          this.$toastr.error(result.message, this.translations('common.error'))
        }
      }).catch(e => {
        console.log('ArchiveSales:API:getFilterdList: error: ', e)
        this.isEmpty = true
        this.isEmptyMsg = this.translations('sale.notice_failed')
        this.$toastr.error(this.isEmptyMsg, this.translations('common.error'))
      }).finally(() => {
        this.isSearching = false
        this.$nextTick(() => {
          this.$vuetify.goTo('.table-scroll', { duration: 0 })
        })
      })
    },

    async listWarehouses () {
      try {
        let { data } = await this.$http.post(`${this.$api_url.warehouse_list}?typeB=true`)
        if (data.status === true) {
          this.warehousesFrom = [ ...data.list, { id: 0, name: '移動元倉庫' } ]
          this.warehousesTo = [ ...data.list, { id: 0, name: '移動先倉庫' } ]
          this.warehousesFrom.sort((a, b) => a.id - b.id)
          this.warehousesTo.sort((a, b) => a.id - b.id)
        } else {
          this.warehousesFrom = [{ id: 0, name: 'No record.' }]
          this.warehousesTo = [{ id: 0, name: 'No record.' }]
        }
      } catch (error) {
        this.$toastr.error(this.translations('sale.notice_failed'), this.translations('common.error'))
      }
    },

    openSingleSales (sale) {
      this.$router.push({ name: 'single-sales', query: { sales_id: sale.id } })
    },

    changedClients (event) {
      if (!event) {
        this.client_id = 0
        return
      }
      this.client_id = event.id
    },

    sliceNote (note) {
      let text = ''
      if (note) {
        let noteLength = note.length
        text = noteLength > 15 ? note.slice(0, 15) + '.....' : note
      }
      return text
    },

    submitSearch () {
      this.initList()
    },

    getShipmentStatusTxt (obj, input, output, _default) {
      if (input) {
        if (input === OrderStatus.ORTHER_SHIPPING) return _default
        return this.$invoiceTools.getObjPropsById(obj, input, output)
      }
      return _default
    },

    getWarehouseFromName (obj, input, output, _default) {
      if (input) {
        return this.$invoiceTools.getObjPropsById(obj, input, output)
      }
      return _default
    },

    getWarehouseToName (obj, input, output, _default) {
      if (input) {
        return this.$invoiceTools.getObjPropsById(obj, input, output)
      }
      return _default
    },

    checkShowWarehouse (statusId) {
      return statusId === OrderStatus.MOVED
    },

    exportCsv () {
      if (this.isSearching) {
        return
      }

      this.isSearching = true

      let warehouseFrom = 0
      let warehouseTo = 0
      if (this.status_id === OrderStatus.MOVED) {
        warehouseFrom = this.warehouseFrom
        warehouseTo = this.warehouseTo
      }

      this.client_id = this.status_id === OrderStatus.MOVED ? 0 : this.client_id

      let params = {
        client_id: this.client_id,
        start_at: this.dateFrom,
        end_at: this.dateTo,
        show_closed: this.isShowClosed,
        search: this.dtSearch,
        status_id: this.status_id,
        warehouse_from: warehouseFrom,
        warehouse_to: warehouseTo
      }
      console.log('ArchiveSales:exportCsv: ', params)

      this.$http.post(this.$api_url.sales_csv, params).then(response => {
        const result = response.data
        console.log('sang', result)
        if (result.status === true) {
          this.isEmpty = false
          this.isEmptyMsg = ''
          this.saveCsv_(result.list)
        } else {
          this.sales = []
          this.$toastr.error(result.message, this.translations('common.error'))
        }
      }).catch(e => {
        console.log('ArchiveSales:API:exportCsv: error: ', e)
        this.isEmpty = true
        this.isEmptyMsg = this.translations('sale.notice_failed')
        this.$toastr.error(this.isEmptyMsg, this.translations('common.error'))
      }).finally(() => {
        this.isSearching = false
        this.$nextTick(() => {
          this.$vuetify.goTo('.table-scroll', { duration: 0 })
        })
      })
    },

    saveCsv_ (list) {
      const data = []
      list.forEach(item => {
        const divisionTypeObj = DivisionType.find(type => type.value === item.division_type)
        const closingFlag = item.closing_flag ? this.translations('sale.billing_created') : this.translations('sale.billing_not_created')
        const clientName = item.division_type === 'A' ? item.client_name : item.name_type_b_from
        const destinationName = item.division_type === 'A' ? item.destination_name : item.name_type_b
        item.details.forEach(detail => {
          data.push([
            closingFlag,
            item.shipping_schedule_at,
            item.shipping_at,
            divisionTypeObj ? this.translations(`order_status.${divisionTypeObj.label}`) : '',
            item.sales_number,
            item.ship_number,
            clientName,
            destinationName,
            detail.warehouse,
            item.total_amount,
            item.gross_profit,
            detail.client_order_number,
            detail.model,
            detail.jan_code,
            detail.internal_memo,
            item.closing_at,
            item.sold_at,
            item.note,
            item.memo
          ])
        })
      })
      let csv = ''
      csv = Papa.unparse({
        fields: [
          this.translations('sale.closing_process'),
          this.translations('sale.ship_date'),
          this.translations('sale.sale_date'),
          this.translations('sale.division'),
          this.translations('sale.order_number'),
          this.translations('sale.ship_number'),
          this.translations('sale.supplier'),
          this.translations('sale.destination_name'),
          this.translations('sale.shipping_warehouse'),
          this.translations('sale.total_amount'),
          this.translations('sale.gross_profit'),
          this.translations('sale.client_order_number'),
          this.translations('sale.model'),
          this.translations('sale.jan_code'),
          this.translations('sale.product_internal_memo'),
          this.translations('sale.closing_date'),
          this.translations('sale.order_date'),
          this.translations('sale.internal_memo'),
          this.translations('sale.remarks')
        ],
        data: data
      })

      const unicodeList = encoding.stringToCode(csv)
      const sjisArray = encoding.convert(unicodeList, 'SJIS', 'UNICODE')
      const uInt8List = new Uint8Array(sjisArray)
      const content = new Blob([uInt8List], { type: 'text/csv' })
      const d = new Date()
      const filename = this.translations('sale.sale_') + d.getFullYear() +
        ('0' + (d.getMonth() + 1)).slice(-2) +
        ('0' + d.getDate()).slice(-2) + '_' +
        ('0' + d.getHours()).slice(-2) +
        ('0' + d.getMinutes()).slice(-2) +
        ('0' + d.getSeconds()).slice(-2) + '.csv'
      saveAs(content, filename)
      this.isLoading = false
    }
  }
}
</script>
